import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import * as Reference from "../../store/ducks/reference.duck";
import * as Admin from "../../store/ducks/admin.duck";
import * as Auth from "../../store/ducks/auth.duck";
import * as Forms from "../../store/ducks/forms.duck";
import { Scheduler, WeekView, MonthView, DayView, SchedulerItem, SchedulerItemContent } from "@progress/kendo-react-scheduler";
import { Button, Modal, Form, Row, Col, Card } from "react-bootstrap";
import { Link } from "react-router-dom";
import { TextField, Grid, Checkbox } from "@material-ui/core";

import { FormWithCustomEditor } from "../../components/scheduler/custom-form";
// import { Tooltip } from '@progress/kendo-react-tooltip';
import { IntlProvider, load, loadMessages, LocalizationProvider } from "@progress/kendo-react-intl";
import { guid } from "@progress/kendo-react-common";
import likelySubtags from "cldr-core/supplemental/likelySubtags.json";
import currencyData from "cldr-core/supplemental/currencyData.json";
import weekData from "cldr-core/supplemental/weekData.json";
import numbers from "cldr-numbers-full/main/en-AU/numbers.json";
import currencies from "cldr-numbers-full/main/en-AU/currencies.json";
import caGregorian from "cldr-dates-full/main/en-AU/ca-gregorian.json";
import dateFields from "cldr-dates-full/main/en-AU/dateFields.json";
import Alert from "@material-ui/lab/Alert";
import { Day } from "@progress/kendo-date-math";
import { parseISO, differenceInMinutes } from "date-fns";
import PhoneIcon from "@material-ui/icons/Phone";
import EmailIcon from "@material-ui/icons/Email";
import { ToastContainer, Flip } from "react-toastify";
import ToDos from "../../components/ToDos";
import UpdatePassword from "../../components/UpdatePassword";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Carousel from "react-bootstrap/Carousel";
import PerfectScrollbar from "react-perfect-scrollbar";
import BookingApproval from "../../components/BookingApproval";
import BookingOutcome from "../../components/BookingOutcome";
import { format } from "date-fns";
import useSearchStringRedirect from "../../router/useSearchStringRedirect"; // Custom hook to handle search string redirects
import Notes from "../../components/Notes";
import SendLetter from "../../components/SendLetter";
import { useHistory } from "react-router-dom";
import "../../../_metronic/_assets/css/app2.css";
import "bootstrap/dist/css/bootstrap.min.css";

load(likelySubtags, currencyData, weekData, numbers, currencies, caGregorian, dateFields);

const displayDate = new Date();

const perfectScrollbarOptions = {
  wheelSpeed: 2,
  wheelPropagation: false,
};

const ClientSendLetter = ({ currentClientID, registered, currentDOB, currentPreferredName, currentFirstName, currentSurname }) => {
  const client = useSelector((state) => state.admin.Client);

  return (
    <SendLetter
      type="Client"
      pkid={currentClientID}
      psychologistFullName={registered.firstname + " " + registered.surname}
      dob={currentDOB}
      firstName={currentPreferredName && currentPreferredName.length > 2 ? currentPreferredName : currentFirstName}
      surname={currentSurname}
      faxGP={client && client.referralGPPracticeFax}
    />
  );
};

export default function DashboardPsychologist(props) {
  const dispatch = useDispatch();
  const history = useHistory();
  const registered = useSelector((state) => state.admin.RegisteredPsychologists[0]);
  const providerSchedulerSetting = useSelector((state) => state.admin.ProviderSchedulerSetting);
  const bookings = useSelector((state) => state.admin.ProviderBookings);
  const availability = useSelector((state) => state.admin.Availability);
  const activityfeed = useSelector((state) => state.admin.ActivityFeed);
  const opportunityFeed = useSelector((state) => state.admin.OpportunityFeed);
  const clients = useSelector((state) => state.admin.Clients);
  // const client = useSelector((state) => state.admin.Client);
  const client = "";
  const userTZ = useSelector((state) => state.auth.userTZ);
  const isRecovery = useSelector((state) => state.auth.recoveryStatus);
  const videoHelpItems = useSelector((state) => state.admin.HelpItems);
  const providerBookingApproval = useSelector((state) => state.admin.ProviderBookingApproval);
  const providerNonCSBookingApproval = providerBookingApproval ? providerBookingApproval.filter((booking) => booking.contractId !== "15") : [];
  const providerCSBookingApproval = providerBookingApproval ? providerBookingApproval.filter((booking) => booking.contractId === "15") : [];
  const providerStatistics = useSelector((state) => state.admin.ProviderStatistics);
  const [showToDo, setShowToDo] = useState(false);
  const [toDoClientID, setToDoClientID] = useState();
  const [toDoTitle, setToDoTitle] = useState("");
  const [showUpdatePassword, setShowUpdatePassword] = useState(false);
  const [showCancelProviderBooking, setShowCancelProviderBooking] = useState(false);
  const [cancelBookingData, setCancelBookingData] = useState(null);
  const [cancellationTypeSMS, setCancellationTypeSMS] = useState(false);
  const [cancellationReason, setCancellationReason] = useState();
  const [cancellationType, setCancellationType] = useState("");
  const [cancellationTypeSMSText, setCancellationTypeSMSText] = useState("");
  const [showAttendanceDialog, setShowAttendanceDialog] = useState(false);
  const [attendanceData, setAttendanceData] = useState(null);
  const [attendanceStatus, setAttendanceStatus] = useState(null);
  const [schedulerKey, setSchedulerKey] = useState(0);
  const [showSchedulerSettings, setShowSchedulerSettings] = useState(false);
  const [booking, setBooking] = useState(null);
  const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const [displayBulkBilling, setDisplayBulkBilling] = useState(false);
  const [isBulkActive, setIsBulkActive] = useState(false);
  const news = useSelector((state) => state.admin.DashboardNews);
  const newsCS = useSelector((state) => state.admin.DashboardCSNews);
  const [newsType, setNewsType] = useState("rhc");
  const currentNews = newsType === "rhc" ? news : newsCS;
  const [clientOpportunityInterest, setClientOpportunityInterest] = useState();
  const [clientOpportunityID, setClientOpportunityID] = useState();
  const [clientOpportunityStatus, setClientOpportunityStatus] = useState();
  const [clientOpportunityRelevantInfo, setClientOpportunityRelevantInfo] = useState();
  const [showOpportunityRelevantInfo, setShowOpportunityRelevantInfo] = useState(false);
  const [currentClient, setcurrentClient] = useState();
  const [showNotes, setShowNotes] = useState(false);
  const [showLetter, setShowLetter] = useState(false);
  const [noteAction, setNoteAction] = useState("SMS");
  const [currentDOB, setcurrentDOB] = useState();
  const [currentClientID, setcurrentClientID] = useState();
  const [currentFirstName, setcurrentFirstName] = useState();
  const [currentPreferredName, setcurrentPreferredName] = useState();
  const [currentSurname, setcurrentSurname] = useState();
  const [currentEmail, setcurrentEmail] = useState();
  const [currentMobilePhone, setcurrentMobilePhone] = useState();
  const [nextBookingDate, setnextBookingDate] = useState();
  const videos = (videoHelpItems || []).filter((item) => item.youtube_url).slice(0, 4);

  useSearchStringRedirect(); // Custom hook to handle search string redirects

  const schedulerMessages = {
    "scheduler.deleteConfirmation": "Are you sure you want to cancel this booking?",
    "scheduler.editorDelete": "Cancel Booking",
    "scheduler.deleteTitle": "Cancel",
    "scheduler.deleteDialogTitle": "Cancel Booking",
  };

  loadMessages(schedulerMessages, "en-AU");

  // const [cancellationType,setCancellationType] = useState('')
  const [expiryBanner, setExpiryBanner] = useState(null);

  useEffect(() => {
    dispatch(Admin.actions.fetchProviderSchedulerSetting());
  }, [dispatch]);
  useEffect(() => {
    dispatch(Admin.actions.fetchRegistered());
  }, [dispatch]);
  // May need to consider this - do providers need to see inactive clients?
  useEffect(() => {
    dispatch(Admin.actions.fetchClients({ status: "Active" }));
  }, [dispatch]);
  useEffect(() => {
    dispatch(Admin.actions.fetchMedicalPractitioners());
  }, [dispatch]);
  useEffect(() => {
    dispatch(Admin.actions.fetchMedicalPractices({ type: "GeneralPractitioner" }));
  }, [dispatch]);
  useEffect(() => {
    dispatch(Forms.actions.fetchForms());
  }, [dispatch]);
  useEffect(() => {
    dispatch(Admin.actions.fetchProviderStatistics());
  }, [dispatch]);
  useEffect(() => {
    dispatch(Reference.actions.fetchTimeZone());
  }, [dispatch]);
  useEffect(() => {
    dispatch(Reference.actions.fetchConstants());
  }, [dispatch]);
  useEffect(() => {
    dispatch(Reference.actions.fetchFundingTypes());
  }, [dispatch]);
  useEffect(() => {
    dispatch(Admin.actions.fetchHelpItems());
  }, [dispatch]);
  useEffect(() => {
    dispatch(Admin.actions.fetchResourceItems());
  }, [dispatch]);
  useEffect(() => {
    dispatch(Admin.actions.fetchBookingTypeStatistics());
  }, [dispatch]);
  useEffect(() => {
    dispatch(Admin.actions.fetchProviderBookingApproval());
  }, [dispatch]);
  useEffect(() => {
    dispatch(Admin.actions.fetchDashboardCSNews());
  }, [dispatch]);
  useEffect(() => {
    dispatch(Admin.actions.fetchDashboardNews());
  }, [dispatch]);
  useEffect(() => {
    dispatch(Admin.actions.fetchOpportunityFeed());
  }, [dispatch]);
  useEffect(() => {
    dispatch(Admin.actions.fetchHelpItems());
  }, [dispatch]);

  useEffect(() => {
    if (registered && userTZ) {
      dispatch(Admin.actions.fetchBookings({ key: "psychologist", id: registered.id }));
      dispatch(
        Admin.actions.fetchAvailability({
          psychologistid: registered.id,
          userTZ: userTZ,
        }),
      );
    }
  }, [dispatch, registered, userTZ]);

  useEffect(() => {
    if (isRecovery === "Recovery") {
      dispatch(Auth.actions.clearRecovery());
      setShowUpdatePassword(true);
    }
  }, [dispatch, isRecovery]);

  useEffect(() => {
    if (!registered?.insuranceexpiry) {
      setExpiryBanner(null);
      return;
    }

    const today = new Date();
    const expiryDate = new Date(registered.insuranceexpiry);
    const oneMonthFromNow = new Date();
    oneMonthFromNow.setMonth(today.getMonth() + 1);
    if (expiryDate < today) {
      setExpiryBanner(
        <Alert severity="error" style={{ marginBottom: 10, marginTop: 10, fontSize: 14 }}>
          <strong>
            Insurance expired on{" "}
            {expiryDate.toLocaleDateString("en-AU", {
              day: "2-digit",
              month: "2-digit",
              year: "numeric",
            })}
            .
          </strong>{" "}
          Please upload new certificate ASAP.
        </Alert>,
      );
    } else if (expiryDate <= oneMonthFromNow) {
      setExpiryBanner(
        <Alert severity="warning" style={{ marginBottom: 10, marginTop: 10, fontSize: 14 }}>
          <strong>Insurance will expire soon</strong> on{" "}
          {expiryDate.toLocaleDateString("en-AU", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
          })}
          . Please upload new certificate before expiry.
        </Alert>,
      );
    } else {
      setExpiryBanner(null);
    }
  }, [registered]);

  useEffect(() => {
    // Determine if bulk billing button can be displayed
    if (
      registered &&
      (registered.providertype === "Psychologist" ||
        registered.providertype === "Clinical" ||
        registered.providertype === "Occupational" ||
        registered.providertype === "Social")
    ) {
      setDisplayBulkBilling(true);
    } else {
      setDisplayBulkBilling(false);
    }
    // Determine if bulk billing button is set
    if (registered && registered.bulkBillingAvailable === "1") {
      setIsBulkActive(true);
    } else {
      setIsBulkActive(false);
    }
  }, [registered]);

  const loadToDos = (clientID, fullName) => {
    setToDoClientID(clientID);
    setToDoTitle(fullName);
    setShowToDo(true);
  };

  function expressInterest() {
    // Close modal
    setShowOpportunityRelevantInfo(false);
    // Make API call to express interest
    dispatch(
      Admin.actions.putClientOpportunityInterest({
        clientOpportunityID: clientOpportunityID,
        providerStatus: clientOpportunityStatus,
        relevantInfo: clientOpportunityRelevantInfo,
      }),
    );
  }

  function withdrawInterest(clientOpportunityID, status) {
    // Make API call to withdraw interest
    dispatch(Admin.actions.putClientOpportunityInterest({ clientOpportunityID: clientOpportunityID, providerStatus: status, relevantInfo: "" }));
  }

  function expressInterestModal(clientOpportunityID, status, interest) {
    // Pop Modal for Relevant Info
    setClientOpportunityInterest(interest);
    setClientOpportunityID(clientOpportunityID);
    setClientOpportunityStatus(status);
    setClientOpportunityRelevantInfo();
    setShowOpportunityRelevantInfo(true);
  }

  const schedulerSettings = {
    workDayStart: providerSchedulerSetting?.workDayStart ?? "06:00",
    workDayEnd: providerSchedulerSetting?.workDayEnd ?? "22:00",
    slotDuration: providerSchedulerSetting?.slotDuration ?? 60,
    slotDivisions: providerSchedulerSetting?.slotDivisions ?? 4,
  };

  const handleSchedulerSettingsSave = (settings) => {
    dispatch(Admin.actions.putProviderSchedulerSetting(settings));
    setSchedulerKey((prev) => prev + 1);
  };

  const SchedulerToolbar = ({ settings, onSave }) => {
    const [showLegend, setShowLegend] = useState(false);
    const [showSettings, setShowSettings] = useState(false);

    const handleSettingsSave = (newSettings) => {
      onSave(newSettings);
      setShowSettings(false);
    };

    return (
      <div className="scheduler-toolbar-container">
        <div className="scheduler-toolbar">
          <button type="button" className="scheduler-toolbar-button scheduler-legend-button" onClick={() => setShowLegend((prev) => !prev)}>
            {showLegend ? "Hide Legend" : "Show Legend"}
          </button>

          <button type="button" className="scheduler-toolbar-button scheduler-settings-button" onClick={() => setShowSettings((prev) => !prev)}>
            {showSettings ? "Hide Settings" : "Show Settings"}
          </button>
        </div>

        {showLegend && (
          <div className="scheduler-legend-panel">
            <SchedulerLegend />
          </div>
        )}

        {showSettings && <SchedulerSettingsHeader settings={settings} onSave={handleSettingsSave} />}
      </div>
    );
  };

  const SchedulerSettingsHeader = ({ settings, onSave }) => {
    const [localSettings, setLocalSettings] = useState(settings);

    useEffect(() => {
      setLocalSettings(settings);
    }, [settings]);

    const handleChange = (field, value) => {
      setLocalSettings((prev) => ({
        ...prev,
        [field]: value,
      }));
    };

    const handleSave = () => {
      onSave(localSettings);
    };

    return (
      <div
        style={{
          display: "flex",
          alignItems: "flex-end",
          justifyContent: "space-between",
          gap: "30px",
          padding: "18px 30px",
          marginBottom: "10px",
          backgroundColor: "#eef6fc",
          border: "1px solid #cfe3f1",
          borderRadius: "4px",
          color: "#2c3e50",
        }}
      >
        <div
          style={{
            fontWeight: "600",
            fontSize: "14px",
            marginRight: "10px",
            paddingBottom: "7px",
            whiteSpace: "nowrap",
          }}
        >
          Scheduler Settings
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "5px",
          }}
        >
          <label
            style={{
              fontWeight: "600",
              fontSize: "12px",
              marginBottom: 0,
            }}
          >
            Work day starts
          </label>

          <input
            type="time"
            value={localSettings.workDayStart}
            onChange={(e) => handleChange("workDayStart", e.target.value)}
            style={{
              height: "38px",
              padding: "6px 10px",
              border: "1px solid #ced4da",
              borderRadius: "4px",
              backgroundColor: "#fff",
            }}
          />
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "5px",
          }}
        >
          <label
            style={{
              fontWeight: "600",
              fontSize: "12px",
              marginBottom: 0,
            }}
          >
            Work day ends
          </label>

          <input
            type="time"
            value={localSettings.workDayEnd}
            onChange={(e) => handleChange("workDayEnd", e.target.value)}
            style={{
              height: "38px",
              padding: "6px 10px",
              border: "1px solid #ced4da",
              borderRadius: "4px",
              backgroundColor: "#fff",
            }}
          />
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "5px",
          }}
        >
          <label
            style={{
              fontWeight: "600",
              fontSize: "12px",
              marginBottom: 0,
            }}
          >
            Slot duration
          </label>

          <select
            value={localSettings.slotDuration}
            onChange={(e) => handleChange("slotDuration", Number(e.target.value))}
            style={{
              height: "38px",
              minWidth: "130px",
              padding: "6px 10px",
              border: "1px solid #ced4da",
              borderRadius: "4px",
              backgroundColor: "#fff",
            }}
          >
            <option value={15}>15 minutes</option>
            <option value={30}>30 minutes</option>
            <option value={60}>60 minutes</option>
          </select>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "5px",
          }}
        >
          <label
            style={{
              fontWeight: "600",
              fontSize: "12px",
              marginBottom: 0,
            }}
          >
            Slot Divisions
          </label>

          <select
            value={localSettings.slotDivisions}
            onChange={(e) => handleChange("slotDivisions", Number(e.target.value))}
            style={{
              height: "38px",
              minWidth: "130px",
              padding: "6px 10px",
              border: "1px solid #ced4da",
              borderRadius: "4px",
              backgroundColor: "#fff",
            }}
          >
            <option value={1}>1</option>
            <option value={2}>2</option>
            <option value={4}>4</option>
          </select>
        </div>
        <button
          type="button"
          onClick={handleSave}
          className="btn btn-primary"
          style={{
            height: "38px",
            padding: "0 20px",
            marginLeft: "10px",
          }}
        >
          Save
        </button>
      </div>
    );
  };

  function updateCancellationTypeSMS(value) {
    setCancellationTypeSMS(value);
  }

  function cancelBooking(id) {
    // Need to handle no show which is triggered if it is save by a provider and reason is not selected - it is like the multiverse
    if (cancellationType === "NoShow") {
      // Update database as client did not show
      dispatch(
        Admin.actions.putAppointment({
          id: id,
          status: "NoShow",
          cancellationReason: cancellationReason,
          refreshPayload: { key: "psychologist", id: registered.id },
        }),
      );
      // Update local display
      setBooking({ ...booking, status: "NoShow" });
      if (cancellationTypeSMS && cancellationTypeSMSText && cancellationTypeSMSText.length > 10) {
        const formData = new FormData();
        formData.append("type", "Client");
        formData.append("pkid", booking.clientID);
        formData.append("subject", "");
        formData.append("selector", "SMS");
        formData.append("note", cancellationTypeSMSText);
        formData.append("faxdestination", "");
        formData.append("faxFile", "");
        formData.append("sendFormID", 0);
        // Ok Time to Dispatch
        process.env.REACT_APP_DEBUG && console.log(...formData);
        dispatch(
          Admin.actions.postNote({
            formData: formData,
            type: "Client",
            pkID: booking.clientID,
          }),
        );
      }
    } else {
      if (cancellationType === "LateCancel") {
        dispatch(
          Admin.actions.putAppointment({
            id: id,
            status: "LateCancel",
            cancellationReason: cancellationReason,
            refreshPayload: { key: "psychologist", id: registered.id },
          }),
        );
        // Update local display
        setBooking({ ...booking, status: "LateCancel" });
      } else {
        if (cancellationType === "LateCancelProvider") {
          dispatch(
            Admin.actions.putAppointment({
              id: id,
              status: "LateCancelProvider",
              cancellationReason: cancellationReason,
              refreshPayload: { key: props.type, id: props.id },
            }),
          );
          // Update local display
          setBooking({ ...booking, status: "LateCancelProvider" });
        } else {
          // Update database as booking cancelled by provider
          dispatch(
            Admin.actions.putAppointment({
              id: id,
              status: "Cancelled",
              cancellationReason: cancellationReason,
              refreshPayload: { key: "psychologist", id: registered.id },
            }),
          );
          // Update local display
          setBooking({ ...booking, status: "Cancelled" });
        }
      }
    }
    // Close provider booking cancel modal - if open
    setShowCancelProviderBooking(false);
  }

  function isTodayMonday() {
    //
    var response = false;
    var today = new Date();
    //
    var day = today.getDay() || 7; // Get current day number, converting Sun. to 7
    if (day === 1) {
      response = true;
    }
    return response;
  }

  // Add legend for the calendar

  const eventColors = {
    meeting: "#FF5733",
    holiday: "#33B5E5",
    task: "#9C27B0",
    personal: "#4CAF50",
  };

  const LEGEND_ITEMS = [
    {
      label: "Availability - Existing Clients",
      striped: true,
      color1: "#575ec2",
      color2: "#0000FF",
    },
    {
      label: "Availability - New Medicare Clients",
      color: "#0000FF",
    },
    {
      label: "Unavailable",
      color: "#800080",
    },
    {
      label: "Availability - Supervision",
      color: "#808080",
    },
    {
      label: "Availability - Contract",
      color: "#21B6A8",
    },
    {
      label: "Availability - Contract New Clients",
      color: "#CDB199",
    },
    {
      label: "Availability - Contract Existing Clients",
      color: "#189AB4",
    },
    {
      label: "Availability - Peri Natal Grief/Loss",
      color: "#E1C340",
    },
    {
      label: "Availability - NthQLDPHN New Clients",
      color: "#D3B1C2",
    },
    {
      label: "Availability - NthQLDPHN Existing Clients",
      color: "#C197D2",
    },
    {
      label: "Availability - NthQLDPHN Face to Face",
      color: "#f6c324",
    },
    {
      label: "Availability - Centralised Service",
      color: "#0d413e",
    },
    {
      label: "Availability - Centralised Service and Medicare New Clients",
      color: "#0d413e",
    },
    {
      label: "Availability - Centralised Service Secondary Case Conference",
      color: "#0d413e",
    },
    {
      label: "Booking - Provisional",
      color: "#FFC0CB",
    },
    {
      label: "Booking - Bulk Billed",
      color: "#133b0a",
    },
    {
      label: "Booking - NDIS",
      color: "#672771",
    },
    {
      label: "Booking - Reduced Gap",
      color: "#6acccc",
    },
    {
      label: "Booking - Contract",
      color: "#256A87",
    },
    {
      label: "Booking - EAP",
      color: "#FFC5D0",
    },
    {
      label: "Booking - Full Fee",
      color: "#cfb94a",
    },
    {
      label: "Booking - TAC",
      color: "#f6c324",
    },
    {
      label: "Booking - WorkCover",
      color: "#f6c324",
    },
    {
      label: "Booking - DVA",
      color: "#f6c324",
    },
    {
      label: "Booking - Island",
      color: "#6acccc",
    },
  ];

  const availabilityItems = LEGEND_ITEMS.filter((x) => x.label.startsWith("Availability") || x.label === "Unavailable");

  const bookingItems = LEGEND_ITEMS.filter((x) => x.label.startsWith("Booking"));

  const LegendItem = ({ item }) => {
    const swatchStyle = item.striped
      ? {
          background: `repeating-linear-gradient(
          45deg,
          ${item.color1},
          ${item.color1} 10px,
          ${item.color2} 10px,
          ${item.color2} 20px
        )`,
        }
      : {
          backgroundColor: item.color,
        };

    return (
      <div className="scheduler-legend-item">
        <span className="scheduler-legend-swatch" style={swatchStyle} />
        <span>{item.label}</span>
      </div>
    );
  };

  const SchedulerLegend = () => {
    return (
      <div className="scheduler-legend">
        <div className="scheduler-legend-title">Calendar Legend</div>

        <div className="scheduler-legend-sections">
          {/* AVAILABILITY */}
          <div className="scheduler-legend-section">
            <div className="scheduler-legend-heading">Availability</div>

            <div className="scheduler-legend-grid">
              {availabilityItems.map((item) => (
                <LegendItem key={item.label} item={item} />
              ))}
            </div>
          </div>

          {/* BOOKINGS */}
          <div className="scheduler-legend-section">
            <div className="scheduler-legend-heading">Bookings</div>

            <div className="scheduler-legend-grid">
              {bookingItems.map((item) => (
                <LegendItem key={item.label} item={item} />
              ))}
            </div>
          </div>
        </div>
      </div>
    );
  };

  // Assemble data from bookings and availability
  const newBookings = bookings
    .filter((r) => r.status !== "Cancelled" && r.status !== "LateCancelProvider")
    .map((row) => {
      return {
        id: row.id,
        clientID: row.clientID,
        eventType: "booking",
        title: row.clientfullname,
        start: parseISO(row.startDate),
        end: parseISO(row.endDate),
        note: row.note,
        paymentType: row.paymentType,
        bookingType: row.bookingType,
        bookingCode: row.bookingCode,
        bookingLocation: row.bookingLocation,
        calendarBookingType: row.calendarBookingType,
        status: row.status,
        contactMobilePhone: row.contactMobilePhone,
        showTodoIcon: row.toDoCount !== 0 ? true : false,
        showRHCManagementLabel: row.rhcmanagement === "Y" ? true : false,
        contractId: row.contractId,
        appointmenttype: row.appointmenttype,
        days: row.days,
        bulkBillingFormStatus: row.bulkBillingFormStatus,
      };
    });
  const newAvailability = availability.map((row) => {
    //
    // Handle change of availabilityType for Display (i.e. Any = All)
    let availabilityTypeDisplay = "Available - New Medicare Client Bookings";
    if (
      row.availabilityType !== "Any" &&
      row.availabilityType !== "New Client Bookings" &&
      row.availabilityType !== "Other" &&
      row.availabilityType !== "NDISContractEAP" &&
      row.availabilityType !== "NDISContractEAPNew" &&
      row.availabilityType !== "NDISContractEAPExisting" &&
      row.availabilityType !== "EAPIsland" &&
      row.availabilityType !== "PerinatalGriefLoss" &&
      row.availabilityType !== "NthQLDPHNNew" &&
      row.availabilityType !== "NthQLDPHNExisting" &&
      row.availabilityType !== "NthQLDPHNFacetoFace" &&
      row.availabilityType !== "CentralisedService"
    ) {
      availabilityTypeDisplay = "Available - Existing";
    }
    if (row.availabilityType === "Other") {
      availabilityTypeDisplay = "Other (Not Available)";
    }
    if (row.availabilityType === "Supervision") {
      availabilityTypeDisplay = "Available - Supervision";
    }
    if (row.availabilityType === "NDISContractEAP") {
      availabilityTypeDisplay = "Available - NDIS/Contract";
    }
    if (row.availabilityType === "NDISContractEAPNew") {
      availabilityTypeDisplay = "Available - New Client or NDIS/Contract";
    }
    if (row.availabilityType === "EAPIsland") {
      availabilityTypeDisplay = "Available - EAP/Island";
    }
    if (row.availabilityType === "NDISContractEAPExisting") {
      availabilityTypeDisplay = "Available - Existing Client or NDIS/Contract";
    }
    if (row.availabilityType === "PerinatalGriefLoss") {
      availabilityTypeDisplay = "Available - Perinatal Grief & Loss";
    }
    if (row.availabilityType === "NthQLDPHNNew") {
      availabilityTypeDisplay = "Available - Nth QLD PHN New Clients";
    }
    if (row.availabilityType === "NthQLDPHNExisting") {
      availabilityTypeDisplay = "Available - Nth QLD PHN Existing Clients";
    }
    if (row.availabilityType === "NthQLDPHNFacetoFace") {
      availabilityTypeDisplay = "Available - Nth QLD PHN Face to Face Clients";
    }
    if (row.availabilityType === "CentralisedService") {
      availabilityTypeDisplay = "Available - Centralised Service";
    }
    if (row.availabilityType === "CentralisedServiceMedicareNew") {
      availabilityTypeDisplay = "Available - Centralised Service and Medicare New Clients";
    }
    if (row.availabilityType === "CentralisedServiceSecondaryCaseConference") {
      availabilityTypeDisplay = "Available - Centralised Service Secondary Case Conference";
    }

    //
    return {
      id: row.id,
      availabiltyType: row.availabilityType,
      eventType: "availability" + row.availabilityType,
      psychologistID: row.psychologistID,
      availabilityType: row.availabilityType,
      title: availabilityTypeDisplay,
      start: new Date(row.startDate),
      end: new Date(row.endDate),
      recurrenceRule: row.rRule && row.rRule.length > 0 ? row.rRule.replace("RRULE:", "") : undefined,
      recurrenceExceptions: row.exDate.length > 0 ? row.exDate.split(",").map((item) => (item.length === 16 ? parseISO(item) : new Date(item))) : [],
    };
  });
  const items = [...newBookings, ...newAvailability];

  // create ref to vars we need to submit with actions, so we can fetch the vales after they have been set by useEffect
  const payloadParams = {
    psychologistID: registered && registered.id,
    userTZ: userTZ,
  };
  const payloadRef = React.useRef(payloadParams);
  React.useEffect(() => {
    payloadRef.current = payloadParams;
  }, [payloadParams]);

  const AttendanceSwitch = ({ value, onChange }) => {
    const isAttended = value;

    const handleToggle = (e) => {
      e.stopPropagation(); // prevent scheduler drag
      onChange(isAttended === "Active" ? "NoShow" : "Active");
    };

    return (
      <div
        className={`kendo-attendance-switch ${isAttended === "Active" ? "on" : "off"}`}
        onClick={handleToggle} // <- click handler attached here
        onMouseDown={(e) => e.stopPropagation()} // prevent drag
        onTouchStart={(e) => e.stopPropagation()}
      >
        <div className="switch-track">
          <div className="switch-thumb" />
          <div className="switch-label-container">
            <span className="switch-label">{isAttended === "Active" ? "Attended" : "Did Not Attend"}</span>
          </div>
        </div>
      </div>
    );
  };

  const isIntegerId = (id) => {
    if (typeof id === "number") return Number.isInteger(id);
    if (typeof id === "string") return /^\d+$/.test(id); // only digits
    return false;
  };

  const AttendanceButton = ({ dataItem, status }) => {
    // Display Button for CS Clients allowing provider to enter notes

    // Check to make sure booking is saved before showing attendance button - this is done by checking if the id is an integer (as new bookings have a string id until saved)
    if (!isIntegerId(dataItem.id)) {
      return null;
    }

    const isAttended = dataItem.status === "Active";
    const handleClick = (e) => {
      e.stopPropagation();
      setAttendanceData(dataItem);
      setAttendanceStatus(status);
      setShowAttendanceDialog(true);
    };
    return (
      <button
        type="button"
        className={`kendo-attendance-btn ${isAttended ? "on" : "off"}`}
        onClick={handleClick}
        onMouseDown={(e) => e.stopPropagation()}
        onTouchStart={(e) => e.stopPropagation()}
      >
        {dataItem.status && dataItem.status === "Active" && status === "Past"
          ? "Mark Attendence"
          : dataItem.status && dataItem.status === "Active" && status === "Upcoming"
            ? "Cancel Booking"
            : dataItem.status}
      </button>
    );
  };

  // Custom item to apply colour for bookings/paymentType vs. availability
  const CustomItem = (props) => {
    var backgroundStyles = { backgroundColor: "blue" };
    switch (props.dataItem.eventType) {
      case "availability":
        backgroundStyles = { backgroundColor: "blue" };
        break;
      case "availabilityExisting":
        backgroundStyles = {
          background: "repeating-linear-gradient(45deg, #575ec2, #575ec2 10px, blue 10px, blue 20px)",
        };
        break;
      case "availabilityAny":
        backgroundStyles = { backgroundColor: "#0000FF" };
        break;
      case "availabilityOther":
        backgroundStyles = { backgroundColor: "#800080" };
        break;
      case "availabilitySupervision":
        backgroundStyles = { backgroundColor: "#808080" };
        break;
      case "availabilityNDISContractEAP":
        backgroundStyles = { backgroundColor: "#21B6A8" };
        break;
      case "availabilityNDISContractEAPNew":
        backgroundStyles = { backgroundColor: "#CDB199" };
        break;
      case "availabilityNDISContractEAPExisting":
        backgroundStyles = { backgroundColor: "#189AB4" };
        break;
      case "availabilityEAPIsland":
        backgroundStyles = { backgroundColor: "#189AB4" };
        break;
      case "availabilityPerinatalGriefLoss":
        backgroundStyles = { backgroundColor: "#E1C340" };
        break;
      case "availabilityNthQLDPHNNew":
        backgroundStyles = { backgroundColor: "#D3B1C2" };
        break;
      case "availabilityNthQLDPHNExisting":
        backgroundStyles = { backgroundColor: "#C197D2" };
        break;
      case "availabilityNthQLDPHNFacetoFace":
        backgroundStyles = { backgroundColor: "#f6c324" };
        break;
      case "availabilityCentralisedService":
        backgroundStyles = { backgroundColor: "#0d413eff" };
        break;
      case "availabilityCentralisedServiceMedicareNew":
        backgroundStyles = { backgroundColor: "#0d413eff" };
        break;
      case "availabilityCentralisedServiceSecondaryCaseConference":
        backgroundStyles = { backgroundColor: "#0d413eff" };
        break;
      default:
        backgroundStyles = { backgroundColor: "#0000FF" };
    }
    switch (props.dataItem.paymentType) {
      case "Provisional":
        backgroundStyles = { backgroundColor: "#FFC0CB" };
        break;
      case "Bulk Billed":
        backgroundStyles = { backgroundColor: "#133b0a" };
        break;
      case "NDIS":
        backgroundStyles = { backgroundColor: "#672771" };
        break;
      case "Reduced Gap":
        backgroundStyles = { backgroundColor: "#6acccc" };
        break;
      case "Contract":
        backgroundStyles = { backgroundColor: "#256A87" };
        break;
      case "EAP":
        backgroundStyles = { backgroundColor: "#FFC5D0" };
        break;
      case "Full Fee":
        backgroundStyles = { backgroundColor: "#cfb94a" };
        break;
      case "TAC":
        backgroundStyles = { backgroundColor: "#f6c324" };
        break;
      case "WorkCover":
        backgroundStyles = { backgroundColor: "#f6c324" };
        break;
      case "DVA":
        backgroundStyles = { backgroundColor: "#f6c324" };
        break;
      default:
        break;
    }

    // Default style on booking status
    if (props.dataItem.eventType === "booking" && props.dataItem.status === "NoShow") {
      backgroundStyles = { backgroundColor: "grey" };
    }
    var customStyles = { ...backgroundStyles, fontSize: 12 };

    const handleDidAttendClick = () => {
      //
      dispatch(
        Admin.actions.putAppointment({
          id: props.dataItem.id,
          status: "MakeActive",
          refreshPayload: { key: "psychologist", id: registered.id },
        }),
      );
    };

    // --- New hover button handler ---
    const handleDidNotAttendClick = () => {
      const client = clients.find((row) => row.id === parseInt(props.dataItem.clientID));
      var bookingData = {
        id: props.dataItem.id,
        clientfullname: props.dataItem.title,
        psychologistfullname: registered.fullname,
        psychologistDate: props.dataItem.start,
        clientID: props.dataItem.clientID,
        paymentType: props.dataItem.paymentType,
        bookingType: props.dataItem.bookingType,
        sessionType: props.dataItem.bookingCode,
        bookingLocation: props.dataItem.bookingLocation,
      };

      setCancellationTypeSMSText(
        `Hello ${client && client.preferredname && client.preferredname.length > 0 ? client.preferredname : client.firstname}, you were scheduled to have an appointment with Rural Health Conect. If you had problems connecting, need assistance or wish to rebook please email referrals@ruralhealthconnect.com.au or call the phone number on our wesbite.`,
      );
      setCancelBookingData(bookingData);
      // Open Provider Cancel Modal
      setShowCancelProviderBooking(true);
    };

    const shouldShowAttendanceButton = props.dataItem.bookingCode !== "Normal" || props.dataItem.paymentType === "EAP" || props.dataItem.contractId === "11";

    return (
      <SchedulerItem {...props} style={{ ...props.style, ...customStyles }}>
        <div className="compact-event">
          <div className="compact-top">
            {/* {props.children} */}

            {props.dataItem.title && <SchedulerItemContent className="event-title">{props.dataItem.title}</SchedulerItemContent>}
          </div>

          {props.dataItem.eventType === "booking" && (
            <SchedulerItemContent>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                  whiteSpace: "nowrap",
                }}
              >
                {props.dataItem.calendarBookingType}

                {props.dataItem.appointmenttype === "1" && <PhoneIcon fontSize="small" />}

                {props.dataItem.showTodoIcon && <EmailIcon fontSize="small" onClick={() => loadToDos(props.dataItem.clientID, props.dataItem.title)} />}
              </div>
            </SchedulerItemContent>
          )}

          {props.dataItem.eventType === "booking" && (
            <div
              onClick={(e) => e.stopPropagation()}
              onMouseDown={(e) => e.stopPropagation()}
              onTouchStart={(e) => e.stopPropagation()}
              style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "8px", width: "100%" }}
            >
              {/* Check to see if the booking has already happended (based on current date/time and booking end time) */}
              {new Date() > props.dataItem.start ? (
                !shouldShowAttendanceButton ? (
                  <AttendanceSwitch
                    value={props.dataItem.status}
                    onChange={(newValue) => {
                      if (newValue === "NoShow") {
                        handleDidNotAttendClick();
                      } else {
                        handleDidAttendClick();
                      }
                      // Optionally update UI state or booking data here
                    }}
                  />
                ) : (
                  <AttendanceButton dataItem={props.dataItem} status="Past" />
                )
              ) : !shouldShowAttendanceButton ? (
                <span
                  style={{
                    color: "white",
                    fontSize: 12,
                    fontWeight: 600,
                    textAlign: "center",
                    display: "block",
                    width: "100%",
                  }}
                >
                  {props.dataItem.status === "NoShow" ? "Did Not Attend" : props.dataItem.status === "Booking Cancelled" ? "Cancelled" : ""}
                </span>
              ) : (
                <AttendanceButton dataItem={props.dataItem} status="Upcoming" />
              )}
            </div>
          )}
        </div>
      </SchedulerItem>
    );
  };

  // We manage both local state and redux state, to make the UI more responsive and not wait for redux.
  // data = local state, updated directly by change events - the calendar displays from this array
  // items = redux state, updated via actions. We only update local from this once the items != prevItems (i.e. redux has changed)
  // So, the sequence is update => update data => send action => items get updated from redux => is now different to prevItems => update data (again) with fresh copy from items
  const [data, setData] = React.useState([]);
  const [prevItems, setPrevItems] = useState([]);

  useEffect(() => {
    if (JSON.stringify(items) !== JSON.stringify(prevItems) && items.length > 0) {
      setPrevItems(items);
      setData(items);
    }
  }, [prevItems, items]);

  function isNumeric(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
  }

  const getUpdateTitle = (item) => {
    switch (item.eventType) {
      case "availability":
        return "Availability";
      case "availabilityAny":
        return "Availability - New Client Medicare Bookings";
      case "availabilityOther":
        return "Availability - Other (Not Available)";
      case "availabilityExisting":
        return "Availability - Existing (Medicare)";
      case "availabilitySupervision":
        return "Availability - Supervision";
      case "availabilityNDISContractEAP":
        return "Availability - NDIS/Contract";
      case "availabilityNDISContractEAPNew":
        return "Availability - New Client or NDIS/Contract";
      case "availabilityNDISContractEAPExisting":
        return "Availability - Existing Client or NDIS/Contract";
      case "availabilityEAPIsland":
        return "Availability - EAP/Island";
      case "availabilityPerinatalGriefLoss":
        return "Availability - Perinatal Grief & Loss";
      case "availabilityNthQLDPHNNew":
        return "Availability - Nth QLD PHN New";
      case "availabilityNthQLDPHNExisting":
        return "Availability - Nth QLD PHN Existing";
      case "availabilityNthQLDPHNFacetoFace":
        return "Availability - Nth QLD PHN Face to Face Clients";
      case "availabilityCentralisedService":
        return "Availability - Centralised Service";
      case "availabilityCentralisedServiceMedicareNew":
        return "Availability - Centralised Service and Medicare New Clients";
      case "availabilityCentralisedServiceSecondaryCaseConference":
        return "Availability - Centralised Service Secondary Case Conference";
      default:
        return clients.find((row) => row.id === parseInt(item.clientID)).fullname;
    }
  };

  //  { created, updated, deleted }
  const handleDataChange = (props) => {
    setData((old) =>
      old
        .filter(
          (item) =>
            props.deleted.find((current) => current.id === item.id) === undefined &&
            props.updated.find((current) => current.id === item.id && current.status === "Cancelled") === undefined,
        )
        .map((item) => props.updated.find((current) => current.id === item.id) || item)
        .concat(
          props.created.map((item) =>
            Object.assign({}, item, {
              id: guid(),
              title: getUpdateTitle(item), // get the proper title to display (e.g. client fullname for bookings)
            }),
          ),
        ),
    );
    var payload = {};
    var duration = 0;
    // Updated
    if (props.updated.length > 0) {
      var changed = props.updated[0];
      if (
        changed.eventType === "availability" ||
        changed.eventType === "availabilityAny" ||
        changed.eventType === "availabilityExisting" ||
        changed.eventType === "availabilityOther" ||
        changed.eventType === "availabilitySupervision" ||
        changed.eventType === "availabilityNDISContractEAP" ||
        changed.eventType === "availabilityNDISContractEAPNew" ||
        changed.eventType === "availabilityNDISContractEAPExisting" ||
        changed.eventType === "availabilityPerinatalGriefLoss" ||
        changed.eventType === "availabilityNthQLDPHNNew" ||
        changed.eventType === "availabilityNthQLDPHNExisting" ||
        changed.eventType === "availabilityNthQLDPHNFacetoFace" ||
        changed.eventType === "availabilityCentralisedService" ||
        changed.eventType === "availabilityEAPIsland" ||
        changed.eventType === "availabilityCentralisedServiceMedicareNew" ||
        changed.eventType === "availabilityCentralisedServiceSecondaryCaseConference"
      ) {
        payload = {
          slot: changed.id,
          id: changed.id,
          mainID: changed.psychologistID,
          startDate: changed.start,
          endDate: changed.end,
          title: changed.title,
          allDay: false,
          rRule: changed.recurrenceRule,
          availabilityType: changed.availabilityType,
          exDate: changed.recurrenceExceptions ? changed.recurrenceExceptions.join(", ") : "",
          userTZ: payloadRef.current.userTZ,
        };
        dispatch(Admin.actions.chgAvailability(payload));
      } else if (changed.eventType === "booking") {
        // If the event being changed has recently been created and has not saved, it has a GUID for an ID and cannot be changed by the API - thus bounce it
        if (isNumeric(changed.id)) {
          duration = differenceInMinutes(new Date(changed.end), new Date(changed.start));
          var status = changed.status === "Active" ? "Updated" : changed.status;
          payload = {
            id: changed.id,
            status: status,
            appointment: {
              id: changed.id,
              userTZ: "UTC", //done
              startDate: changed.start,
              duration: duration,
              clientID: changed.clientID, // done
              psychologistID: payloadRef.current.psychologistID, // done
              note: changed.note,
              paymentType: changed.paymentType,
              bookingType: changed.bookingType,
              bookingCode: changed.bookingCode,
              bookingLocation: changed.bookingLocation,
              status: status,
            },
            refreshPayload: {
              key: "psychologist",
              id: payloadRef.current.psychologistID,
            },
          };
          dispatch(Admin.actions.putAppointment(payload));
        }
      }
    }
    // Added
    if (props.created.length > 0) {
      var added = props.created[0];
      if (
        added.title === "a" ||
        added.eventType === "availability" ||
        added.eventType === "availabilityAny" ||
        added.eventType === "availabilityExisting" ||
        added.eventType === "availabilityOther" ||
        added.eventType === "availabilitySupervision" ||
        added.eventType === "availabilityNDISContractEAP" ||
        added.eventType === "availabilityNDISContractEAPNew" ||
        added.eventType === "availabilityNDISContractEAPExisting" ||
        added.eventType === "availabilityPerinatalGriefLoss" ||
        added.eventType === "availabilityNthQLDPHNNew" ||
        added.eventType === "availabilityNthQLDPHNExisting" ||
        added.eventType === "availabilityNthQLDPHNFacetoFace" ||
        added.eventType === "availabilityCentralisedService" ||
        added.eventType === "availabilityCentralisedServiceMedicareNew" ||
        added.eventType === "availabilityCentralisedServiceSecondaryCaseConference" ||
        added.eventType === "availabilityEAPIsland"
      ) {
        // Need to determine availabilityType
        let availabilityType;
        switch (added.eventType) {
          case "availability":
            availabilityType = "Any";
            break;
          case "availabilityExisting":
            availabilityType = "Existing";
            break;
          case "availabilityOther":
            availabilityType = "Other";
            break;
          case "availabilitySupervision":
            availabilityType = "Supervision";
            break;
          case "availabilityNDISContractEAP":
            availabilityType = "NDISContractEAP";
            break;
          case "availabilityNDISContractEAPNew":
            availabilityType = "NDISContractEAPNew";
            break;
          case "availabilityNDISContractEAPExisting":
            availabilityType = "NDISContractEAPExisting";
            break;
          case "availabilityEAPIsland":
            availabilityType = "EAPIsland";
            break;
          case "availabilityPerinatalGriefLoss":
            availabilityType = "PerinatalGriefLoss";
            break;
          case "availabilityNthQLDPHNNew":
            availabilityType = "NthQLDPHNNew";
            break;
          case "availabilityNthQLDPHNExisting":
            availabilityType = "NthQLDPHNExisting";
            break;
          case "availabilityNthQLDPHNFacetoFace":
            availabilityType = "NthQLDPHNFacetoFace";
            break;
          case "availabilityCentralisedService":
            availabilityType = "CentralisedService";
            break;
          case "availabilityCentralisedServiceMedicareNew":
            availabilityType = "CentralisedServiceMedicareNew";
            break;
          case "availabilityCentralisedServiceSecondaryCaseConference":
            availabilityType = "CentralisedServiceSecondaryCaseConference";
            break;
          case "availabilityAny":
            availabilityType = "Any";
            break;
          default:
            availabilityType = "Any";
        }
        payload = {
          mainID: payloadRef.current.psychologistID,
          startDate: added.start,
          endDate: added.end,
          title: added.title,
          allDay: false,
          rRule: added.recurrenceRule,
          availabilityType: availabilityType,
          exDate: "",
          userTZ: payloadRef.current.userTZ,
        };
        dispatch(Admin.actions.addAvailability(payload));
      } else if (added.eventType === "booking") {
        duration = differenceInMinutes(new Date(added.end), new Date(added.start));
        payload = {
          timezone: "UTC", //done
          newbookingdate: added.start,
          duration: duration,
          clientID: added.clientID, // done
          psychologistID: payloadRef.current.psychologistID, // done
          note: added.note,
          paymentType: added.paymentType,
          bookingType: added.bookingType,
          bookingCode: added.bookingCode,
          bookingLocation: added.bookingLocation,
          refreshPayload: {
            key: "psychologist",
            id: payloadRef.current.psychologistID,
          },
          source: "ProviderPortal",
        };
        dispatch(Admin.actions.bookAppointment(payload));
      }
    }
    // Deleted
    if (props.deleted.length > 0) {
      var deleted = props.deleted[0];
      if (
        deleted.eventType === "availability" ||
        deleted.eventType === "availabilityAny" ||
        deleted.eventType === "availabilityExisting" ||
        deleted.eventType === "availabilityOther" ||
        deleted.eventType === "availabilitySupervision" ||
        deleted.eventType === "availabilityNDISContractEAP" ||
        deleted.eventType === "availabilityNDISContractEAPNew" ||
        deleted.eventType === "availabilityNDISContractEAPExisting" ||
        deleted.eventType === "availabilityPerinatalGriefLoss" ||
        deleted.eventType === "availabilityNthQLDPHNNew" ||
        deleted.eventType === "availabilityNthQLDPHNExisting" ||
        deleted.eventType === "availabilityNthQLDPHNFacetoFace" ||
        deleted.eventType === "availabilityCentralisedService" ||
        deleted.eventType === "availabilityCentralisedServiceMedicareNew" ||
        deleted.eventType === "availabilityCentralisedServiceSecondaryCaseConference" ||
        deleted.eventType === "availabilityEAPIsland"
      ) {
        payload = {
          slot: deleted.id,
          mainID: payloadRef.current.psychologistID,
          userTZ: payloadRef.current.userTZ,
        };
        dispatch(Admin.actions.delAvailability(payload));
      } else if (deleted.eventType === "booking") {
        dispatch(
          Admin.actions.putAppointment({
            id: deleted.id,
            status: "Cancelled",
            appointment: {
              id: deleted.id,
              userTZ: "UTC", //done
              startDate: deleted.start,
              clientID: deleted.clientID, // done
              psychologistID: payloadRef.current.psychologistID, // done
              status: status,
            },
            refreshPayload: {
              key: "psychologist",
              id: payloadRef.current.psychologistID,
            },
          }),
        );
      }
    }
  };

  const handleSchedulerDataChange = (props) => {
    if (props.deleted?.length > 0) {
      const deleted = props.deleted[0];

      if (deleted.eventType === "booking") {
        // Check if it is CS Booking
        if (deleted.contractId === "15") {
          // It is a CS Booking
          setAttendanceData(deleted);
          setAttendanceStatus(deleted.days);
          setShowAttendanceDialog(true);
        } else {
          // Non-CS Booking
          const client = clients.find((row) => row.id === parseInt(deleted.clientID));
          var bookingData = {
            id: deleted.id,
            clientfullname: deleted.title,
            psychologistfullname: registered.fullname,
            psychologistDate: deleted.start,
            clientID: deleted.clientID,
            paymentType: deleted.paymentType,
            bookingType: deleted.bookingType,
            sessionType: deleted.bookingCode,
            bookingLocation: deleted.bookingLocation,
          };
          setCancellationTypeSMSText(
            `Hello ${client && client.preferredname && client.preferredname.length > 0 ? client.preferredname : client.firstname}, you were scheduled to have an appointment with Rural Health Conect. If you had problems connecting, need assistance or wish to rebook please email referrals@ruralhealthconnect.com.au or call the phone number on our wesbite.`,
          );
          setCancelBookingData(bookingData);
          // Open Provider Cancel Modal
          setShowCancelProviderBooking(true);
        }
        // IMPORTANT:
        // Do not call handleDataChange().
        // This prevents the booking from being deleted.
        return;
      }
    }

    // Everything else behaves exactly as it does currently
    handleDataChange(props);
  };

  const handleBulkbillingAvailableChange = () => {
    if (registered && registered.bulkBillingAvailable === "0") {
      // setBulkBillingAvailable("1")
      dispatch(Admin.actions.chgBulkBillingAvailability({ id: registered.id, bulkBillingAvailability: "1" }));
    } else {
      // setBulkBillingAvailable("0")
      dispatch(Admin.actions.chgBulkBillingAvailability({ id: registered.id, bulkBillingAvailability: "0" }));
    }
  };

  const styles = {
    card: {
      border: 0,
      borderRadius: 10,
      height: "100%",
    },

    statisticsCard: {
      border: 0,
      borderRadius: 10,
    },

    heading: {
      fontSize: 15,
      fontWeight: 600,
      color: "#23395d",
      marginBottom: 15,
    },

    cardHeader: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      marginBottom: 12,
    },

    controlButton: {
      width: "100%",
      border: 0,
      color: "#fff",
      fontWeight: 600,
      marginBottom: 9,
      height: 40,
      borderRadius: 6,
    },

    activeTab: {
      border: 0,
      borderRadius: 20,
      background: "#5c5de0",
      color: "#fff",
      marginRight: 6,
      fontWeight: 600,
    },

    inactiveTab: {
      border: 0,
      borderRadius: 20,
      background: "#edf0f6",
      color: "#68748a",
      fontWeight: 600,
    },

    featureBox: {
      background: "#fffaf0",
      border: "1px solid #ead9a7",
      borderRadius: 10,
      padding: 20,
      minHeight: 260,
      display: "flex",
      flexDirection: "column",
    },

    tag: {
      display: "inline-block",
      background: "#d8c833",
      color: "#35406d",
      borderRadius: 5,
      padding: "4px 8px",
      fontSize: 11,
      fontWeight: 600,
      marginRight: 8,
    },

    date: {
      color: "#8490a0",
      fontSize: 11,
    },

    featureTitle: {
      color: "#26395d",
      fontSize: 20,
      marginTop: 15,
      marginBottom: 8,
    },

    featureText: {
      color: "#68748a",
      fontSize: 14,
      lineHeight: 1.6,
    },

    link: {
      color: "#535ce4",
      textDecoration: "none",
      fontSize: 13,
      fontWeight: 500,
    },

    dots: {
      textAlign: "center",
      color: "#cbd0e0",
      fontSize: 12,
      marginTop: 10,
    },

    videoBox: {
      height: 190,
      background: "#181b21",
      borderRadius: 8,
      position: "relative",
      color: "#fff",
      padding: 15,
      marginBottom: 14,
    },

    videoTitle: {
      fontWeight: 600,
      fontSize: 14,
    },

    playButton: {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      background: "#e52d35",
      borderRadius: 8,
      padding: "9px 15px",
    },

    videoTime: {
      position: "absolute",
      right: 12,
      bottom: 10,
      fontSize: 11,
    },

    notificationList: {
      maxHeight: 250,
      overflowY: "auto",
    },
  };

  function loadNotes(thisClient, noteAction) {
    setNoteAction(noteAction);
    setcurrentClientID(thisClient.id);
    setcurrentFirstName(thisClient.firstname);
    setcurrentPreferredName(thisClient.preferredname);
    setcurrentSurname(thisClient.surname);
    setnextBookingDate(thisClient.nextBooking);
    setcurrentEmail(thisClient.email);
    setcurrentMobilePhone(thisClient.mobilephone);
    setShowNotes(true);
  }

  function handleClientAutocompleteChange(propertyName, event, newValue) {
    if (newValue) {
      // console.log(newValue);
      setcurrentClient(newValue);
      setcurrentClientID(newValue.id);
      setcurrentFirstName(newValue.firstname);
      setcurrentPreferredName(newValue.preferredname);
      setcurrentSurname(newValue.surname);
      // console.log(registered);
      dispatch(Admin.actions.fetchClient({ clientID: newValue.id, type: registered.providertype }));
    }
  }

  function sendLetter(thisClient) {
    setNoteAction(noteAction);
    setcurrentClientID(thisClient.id);
    setcurrentFirstName(thisClient.firstname);
    setcurrentPreferredName(thisClient.preferredname);
    setcurrentSurname(thisClient.surname);
    setcurrentDOB(thisClient.dob);
    setShowLetter(true);
  }

  function ReviewPlatFormCosts() {
    // console.log(history)
    history.push("/platform");
  }

  function Stat({ value, label }) {
    return (
      <div
        style={{
          flex: 1,
          minWidth: 0,
          background: "#fff",
          border: "1px solid #e1e4ea",
          borderRadius: 8,
          padding: "14px 16px",
          minHeight: 100,
        }}
      >
        <div
          style={{
            fontSize: 28,
            fontWeight: 600,
            color: "#286f7c",
            lineHeight: 1,
          }}
        >
          {value}
        </div>

        <div
          style={{
            marginTop: 8,
            fontSize: 12,
            color: "#566",
          }}
        >
          {label}
        </div>
      </div>
    );
  }

  function VideoLink({ text, youtubeUrl }) {
    return (
      <a
        href={youtubeUrl}
        target="_blank"
        rel="noopener noreferrer"
        style={{
          display: "flex",
          alignItems: "center",
          marginBottom: 8,
          textDecoration: "none",
        }}
      >
        <div
          style={{
            width: 44,
            height: 30,
            background: "#e9ebf3",
            borderRadius: 4,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginRight: 10,
            color: "#888",
          }}
        >
          ▶
        </div>

        <span
          style={{
            color: "#5961e8",
            fontSize: 14,
          }}
        >
          {text}
        </span>
      </a>
    );
  }

  return (
    <>
      {expiryBanner && <div style={{ marginBottom: "1rem", marginLeft: "-10px" }}>{expiryBanner}</div>}

      <div style={{ background: "#f1f3f8" }}>
        {/* TOP ROW */}
        <Row className="g-3">
          {/* CONTROL PANEL */}
          <Col md={3}>
            <Card style={{ height: "100%", border: 0, borderRadius: 10 }}>
              <Card.Body>
                <>
                  <h5 style={styles.heading}>Control panel</h5>

                  {registered && registered.specialisttype === "centralisedservice" ? (
                    <>
                      <a href={"https://vcc.healthdirect.org.au/login"} target="_blank" rel="noopener noreferrer">
                        <Button style={{ ...styles.controlButton, backgroundColor: "#a0ad36" }}>▶ Enter COVIU</Button>
                      </a>
                      <a href={registered && registered.waitingRoomURL} target="_blank" rel="noopener noreferrer">
                        <Button style={{ ...styles.controlButton, backgroundColor: "#a0ad36" }}>▶ Enter TeleHealth</Button>
                      </a>
                    </>
                  ) : (
                    <>
                      <a href={registered && registered.waitingRoomURL} target="_blank" rel="noopener noreferrer">
                        <Button style={{ ...styles.controlButton, backgroundColor: "#a0ad36" }}>▶ Enter TeleHealth</Button>
                      </a>
                    </>
                  )}
                  {displayBulkBilling ? (
                    <Button
                      style={{
                        ...styles.controlButton,
                        backgroundColor: isBulkActive ? "#35a7b9" : "#777",
                      }}
                      onClick={handleBulkbillingAvailableChange}
                    >
                      <span
                        style={{
                          display: "inline-block",
                          width: 36,
                          height: 20,
                          borderRadius: 10,
                          backgroundColor: isBulkActive ? "#fff" : "#ccc",
                          verticalAlign: "middle",
                          marginRight: 8,
                          position: "relative",
                        }}
                      >
                        <span
                          style={{
                            position: "absolute",
                            top: 2,
                            left: isBulkActive ? 18 : 2,
                            width: 16,
                            height: 16,
                            borderRadius: "50%",
                            backgroundColor: isBulkActive ? "#35a7b9" : "#777",
                            transition: "left 0.2s",
                          }}
                        />
                      </span>
                      Bulk Billing · {isBulkActive ? "Active" : "Inactive"}
                    </Button>
                  ) : null}
                  <Button style={{ ...styles.controlButton, backgroundColor: "#347fc1" }} onClick={() => loadNotes(client, "SMS")}>
                    Quick Action
                  </Button>

                  <Button style={{ ...styles.controlButton, backgroundColor: "#b13991" }} onClick={() => sendLetter(client)}>
                    ✉ Send Letter
                  </Button>

                  <Button style={{ ...styles.controlButton, backgroundColor: "#d1aa20" }} onClick={() => ReviewPlatFormCosts()}>
                    Review Invoice
                  </Button>
                </>
              </Card.Body>
            </Card>
          </Col>
          {/* NEWS */}
          <Col md={5}>
            <Card style={styles.card}>
              <Card.Body>
                <div style={styles.cardHeader}>
                  <h5 style={styles.heading}>News and Updates</h5>
                  <div>
                    <Button size="sm" style={newsType === "rhc" ? styles.activeTab : styles.inactiveTab} onClick={() => setNewsType("rhc")}>
                      Rural Health Connect
                    </Button>
                    {registered && registered.specialisttype === "centralisedservice" && (
                      <Button size="sm" style={newsType === "cs" ? styles.activeTab : styles.inactiveTab} onClick={() => setNewsType("cs")}>
                        Centralised Service
                      </Button>
                    )}
                  </div>
                </div>
                {/* "pdf_url":"https://www.ruralthealthconnect.com.au" */}
                <Carousel
                  controls={true}
                  indicators={true}
                  variant="dark"
                  className="news-carousel"
                  style={{
                    height: 337,
                    position: "relative",
                    overflow: "visible",
                  }}
                >
                  {currentNews &&
                    Array.isArray(currentNews) &&
                    [...currentNews]
                      .sort((a, b) => a.sortIndex - b.sortIndex)
                      .map((itm, idx) => (
                        <Carousel.Item key={idx}>
                          <div
                            style={{
                              width: "80%",
                              height: "280px",
                              margin: "0 auto",
                              display: "flex",
                              alignItems: "center",
                              boxSizing: "border-box",
                            }}
                          >
                            {/* Yellow news background */}
                            <div
                              style={{
                                height: 250,
                                backgroundColor: "#fff3cd",
                                borderRadius: 8,
                                padding: "15px 25px",
                                boxSizing: "border-box",
                              }}
                            >
                              {" "}
                              <div>
                                <span style={styles.tag}>{newsType === "rhc" ? "Rural Health Connect" : "Centralised Service"}</span>

                                {itm.postDate && <span style={styles.date}>{itm.postDate}</span>}
                              </div>
                              <h4 style={styles.featureTitle}>{itm.title}</h4>
                              <p style={styles.featureText}>{itm.copy}</p>
                              {itm.pdf_url && (
                                <a href={itm.pdf_url} style={styles.link}>
                                  Learn more →
                                </a>
                              )}
                            </div>
                          </div>
                        </Carousel.Item>
                      ))}
                </Carousel>
              </Card.Body>
            </Card>
          </Col>
          {/* VIDEO */}
          <Col md={4}>
            <Card style={styles.card}>
              <Card.Body>
                <h5 style={styles.heading}>Video updates</h5>

                {videos.length > 0 ? (
                  <>
                    {/* FEATURED VIDEO */}
                    <a href={videos[0].youtube_url} target="_blank" rel="noopener noreferrer" style={{ textDecoration: "none" }}>
                      <div
                        style={{
                          ...styles.videoBox,
                          cursor: "pointer",
                        }}
                      >
                        <div style={styles.videoTitle}>{videos[0].title}</div>

                        <div style={styles.playButton}>▶</div>
                      </div>
                    </a>
                    {/* OTHER VIDEOS */}
                    {videos.slice(1).map((item) => (
                      <VideoLink key={item.id} text={item.title} youtubeUrl={item.youtube_url} />
                    ))}
                    <Link
                      to="/howtoarticles"
                      style={{
                        display: "inline-block",
                        marginTop: 15,
                        textDecoration: "none",
                      }}
                    >
                      <Button
                        size="sm"
                        style={{
                          backgroundColor: "#5961e8",
                          borderColor: "#5961e8",
                          borderRadius: 20,
                          fontSize: 12,
                          fontWeight: 600,
                          padding: "7px 14px",
                        }}
                      >
                        View All our How-To videos
                      </Button>
                    </Link>
                  </>
                ) : null}
              </Card.Body>
            </Card>
          </Col>
        </Row>

        {/* SECOND ROW */}
        <Row className="g-3 mt-3">
          {/* NOTIFICATIONS */}
          <Col md={6}>
            <Card style={styles.card}>
              <Card.Body>
                <div style={styles.cardHeader}>
                  <h5 style={styles.heading}>Notifications</h5>
                </div>

                <PerfectScrollbar
                  options={perfectScrollbarOptions}
                  style={{
                    maxHeight: 410,
                    position: "relative",
                  }}
                >
                  <div>
                    {activityfeed &&
                      activityfeed.map((item, index) => (
                        <Link
                          key={index}
                          to={item.link ? item.link : "/dashboard"}
                          onClick={() =>
                            dispatch(
                              Admin.actions.setFilters({
                                filterName: "clientsListLoadClientID",
                                filterValue: item.clientID,
                              }),
                            )
                          }
                          style={{
                            display: "block",
                            textDecoration: "none",
                            color: "inherit",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "flex-start",
                              padding: "10px 5px",
                              borderBottom: "1px solid #eef0f4",
                            }}
                          >
                            {/* ICON */}
                            <div
                              style={{
                                width: 34,
                                height: 34,
                                minWidth: 34,
                                borderRadius: "50%",
                                backgroundColor: "#f1f3f7",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                marginRight: 12,
                              }}
                            >
                              <i
                                className={item.icon}
                                style={{
                                  color: item.colour,
                                  fontSize: 14,
                                }}
                              />
                            </div>

                            {/* DETAILS */}
                            <div style={{ flex: 1 }}>
                              <div
                                style={{
                                  color: item.colour,
                                  fontSize: 13,
                                  fontWeight: 500,
                                  lineHeight: 1.4,
                                }}
                              >
                                {item.label}
                              </div>

                              {item.additional && (
                                <div
                                  style={{
                                    color: "#566273",
                                    fontSize: 13,
                                    lineHeight: 1.4,
                                    marginTop: 2,
                                  }}
                                >
                                  {item.additional}
                                </div>
                              )}

                              <div
                                style={{
                                  color: "#8490a0",
                                  fontSize: 11,
                                  marginTop: 3,
                                }}
                              >
                                {item.created}
                              </div>
                            </div>
                          </div>
                        </Link>
                      ))}
                  </div>
                </PerfectScrollbar>
              </Card.Body>
            </Card>
          </Col>
          {/* OPPORTUNITIES */}
          <Col md={6}>
            <Card style={styles.card}>
              <Card.Body>
                <h5 style={styles.heading}>Available opportunities</h5>

                <PerfectScrollbar
                  options={perfectScrollbarOptions}
                  style={{
                    maxHeight: 410,
                    minHeight: 410,
                    position: "relative",
                  }}
                >
                  <div style={{ paddingRight: 8 }}>
                    {opportunityFeed &&
                      opportunityFeed.map((item) => (
                        <div
                          key={item.id}
                          style={{
                            ...styles.featureBox,
                            minHeight: 190,
                            marginBottom: 15,
                          }}
                        >
                          <div>
                            <span style={styles.tag}>Rural Health Connect</span>

                            <span style={styles.date}>Listed {item.created}</span>
                          </div>

                          <p
                            style={{
                              ...styles.featureText,
                              color: "#566273",
                              marginTop: 15,
                              marginBottom: 2,
                            }}
                          >
                            {item.description}
                          </p>

                          <div
                            style={{
                              textAlign: "right",
                            }}
                          >
                            <Button
                              size="sm"
                              onClick={() =>
                                item.interestcreatedon ? withdrawInterest(item.id, "Withdraw") : expressInterestModal(item.id, "Express", item.description)
                              }
                              style={{
                                backgroundColor: item.colour,
                                borderColor: item.colour,
                                color: "#fff",
                                fontSize: 13,
                                fontWeight: 500,
                                padding: "6px 12px",
                                width: "auto",
                              }}
                            >
                              {item.interestcreatedon ? "Withdraw Interest" : "Express Interest"}
                            </Button>
                          </div>
                        </div>
                      ))}
                  </div>
                </PerfectScrollbar>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        {/* STATISTICS */}
        <Row className="mt-3">
          <Col md={12}>
            <Card style={styles.statisticsCard}>
              <Card.Body>
                <div style={styles.cardHeader}>
                  <h5 style={styles.heading}>Your Statistics</h5>
                </div>
                <div
                  style={{
                    display: "flex",
                    gap: 12,
                    width: "100%",
                  }}
                >
                  <Stat value={providerStatistics?.activeClients || "N/A"} label="Active clients" />
                  <Stat value={providerStatistics?.averageNumberSessionsPerClient || "N/A"} label="Avg sessions per client" />
                  <Stat value={providerStatistics?.averageNumberRHCSessionsPerClient || "N/A"} label="RHC Average sessions per client" />
                  <Stat value={providerStatistics?.upcomingBookings || "N/A"} label="Upcoming bookings" />
                  <Stat value={providerStatistics?.bookingsOverPast30Days || "N/A"} label="Bookings (past 30 days)" />
                  <Stat value={providerStatistics?.totalSessionsDeliveredViaRHC || "N/A"} label="Sessions delivered" />
                  <Stat value={providerStatistics?.totalBulkBilledSessions || "N/A"} label="Bulk billed sessions" />
                  <Stat
                    value={
                      providerStatistics?.bulkBilledRatioOverPast30Days != null
                        ? `${Math.round(parseFloat(providerStatistics.bulkBilledRatioOverPast30Days))}%`
                        : "N/A"
                    }
                    label="Bulk Billed Percentage (30 days)"
                  />
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        {providerCSBookingApproval && providerCSBookingApproval.length > 0 ? <BookingApproval approvalType="CS" /> : null}
        {providerNonCSBookingApproval && providerNonCSBookingApproval.length > 0 ? <BookingApproval approvalType="Standard" /> : null}
      </div>

      <div className="row" style={{ marginTop: 20 }}>
        <div className="col-xl-12">
          <div className="kt-portlet kt-portlet--height-fluid">
            <div className="kt-portlet__body" style={{ padding: 0 }}>
              <div className="kt-widget4">
                <LocalizationProvider language="en-AU">
                  <IntlProvider locale="en-AU" messages={schedulerMessages}>
                    <SchedulerToolbar settings={schedulerSettings} onSave={handleSchedulerSettingsSave} />
                    <Scheduler
                      key={schedulerKey}
                      data={data}
                      onDataChange={handleSchedulerDataChange}
                      timezone={userTimeZone}
                      item={CustomItem}
                      defaultDate={displayDate}
                      defaultView="week"
                      editable={{
                        add: true,
                        drag: true,
                        resize: true,
                        edit: true,
                        remove: true,
                      }}
                      form={FormWithCustomEditor}
                      height={900}
                    >
                      <DayView slotDuration={schedulerSettings.slotDuration} slotDivisions={schedulerSettings.slotDivisions} />
                      <WeekView
                        title="Week"
                        selectedDateFormat="{0:M}"
                        selectedShortDateFormat="{0:M}"
                        workDayStart={schedulerSettings.workDayStart}
                        workDayEnd={schedulerSettings.workDayEnd}
                        workWeekStart={Day.Monday}
                        slotDuration={schedulerSettings.slotDuration}
                        slotDivisions={schedulerSettings.slotDivisions}
                      />
                      <MonthView />
                    </Scheduler>
                  </IntlProvider>
                </LocalizationProvider>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ToastContainer
        position="bottom-right"
        transition={Flip}
        autoClose={5000}
        hideProgressBar={true}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />

      <Modal show={showToDo} onHide={() => setShowToDo(false)} dialogClassName="todos-modal-dialog">
        <Modal.Header closeButton className="todos-modal">
          <Modal.Title>To Do - {toDoTitle}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="todos-modal">{toDoClientID && <ToDos clientID={toDoClientID} setShowToDo={setShowToDo} />}</Modal.Body>
      </Modal>

      <Modal show={showUpdatePassword} onHide={() => setShowUpdatePassword(false)} dialogClassName="todos-modal-dialog">
        <Modal.Header closeButton className="todos-modal">
          <Modal.Title>You have recently recovered your password, please update your password</Modal.Title>
        </Modal.Header>
        <Modal.Body className="todos-modal">
          <UpdatePassword setShowUpdatePassword={setShowUpdatePassword} />
        </Modal.Body>
      </Modal>

      <Modal
        show={showAttendanceDialog}
        onHide={() => setShowAttendanceDialog(false)}
        size="lg" // "sm" | "lg" | "xl"
        dialogClassName="note-modal"
        style={{ zIndex: 1150 }}
        centered
      >
        <Modal.Header closeButton className="notes-modal">
          <Modal.Title>Booking with {attendanceData && attendanceData.title ? attendanceData.title : ""}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="notes-modal" style={{ backgroundColor: "rgb(245,245,245)" }}>
          <BookingOutcome
            name={attendanceData && attendanceData.title ? attendanceData.title : ""}
            start={attendanceData && attendanceData.start ? attendanceData.start : null}
            end={attendanceData && attendanceData.end ? attendanceData.end : null}
            status={attendanceData && attendanceData.status ? attendanceData.status : ""}
            clientID={attendanceData && attendanceData.clientID ? attendanceData.clientID : null}
            bookingID={attendanceData && attendanceData.id ? attendanceData.id : null}
            contractId={attendanceData && attendanceData.contractId ? attendanceData.contractId : null}
            paymentType={attendanceData && attendanceData.paymentType ? attendanceData.paymentType : ""}
            psychologistID={registered && registered.id ? registered.id : null}
            attendanceStatus={attendanceStatus}
            closeModal={setShowAttendanceDialog}
            source="Calendar"
          />
        </Modal.Body>
      </Modal>

      <Modal
        show={showCancelProviderBooking}
        onHide={() => setShowCancelProviderBooking(false)}
        dialogClassName="new-bookingDialog-modal"
        style={{ zIndex: 1150 }}
        centered
      >
        <Modal.Header closeButton className="new-booking-modal">
          <Modal.Title>Booking with {cancelBookingData && cancelBookingData.clientfullname ? cancelBookingData.clientfullname : ""}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="new-booking-modal" style={{ backgroundColor: "rgb(245,245,245)" }}>
          <Grid container spacing={3}>
            <Grid item md={3} xs={6}>
              Client:
            </Grid>
            <Grid item md={9} xs={6} style={{ fontWeight: 600 }}>
              {cancelBookingData && cancelBookingData.clientfullname ? cancelBookingData.clientfullname : ""}
            </Grid>
            <Grid item md={3} xs={6}>
              Date:
            </Grid>
            <Grid item md={9} xs={6} style={{ fontWeight: 600 }}>
              {cancelBookingData && cancelBookingData.psychologistDate ? format(new Date(cancelBookingData.psychologistDate), "dd-MM-yyyy") : ""}
            </Grid>
            <Grid item md={3} xs={6}>
              Time:
            </Grid>
            <Grid item md={9} xs={6} style={{ fontWeight: 600 }}>
              {cancelBookingData && cancelBookingData.psychologistDate ? format(new Date(cancelBookingData.psychologistDate), "h:mm aa") : ""}
            </Grid>
            <Grid item md={3} xs={6}>
              Payment Type:
            </Grid>
            <Grid item md={9} xs={6} style={{ fontWeight: 600 }}>
              {cancelBookingData && cancelBookingData.paymentType ? cancelBookingData.paymentType : ""}
            </Grid>
            <hr />
            <Grid item md={12} xs={6}>
              <Form.Group>
                <Form.Label style={{ fontWeight: 600, paddingBottom: 10 }}>Why is this booking being cancelled?</Form.Label>
                <Form.Check id="cancellationType-NoShow" name="noShowCancellation" type="radio" style={{ marginBottom: 8 }}>
                  <Form.Check.Input
                    name="NoShow"
                    type="radio"
                    checked={cancellationType === "NoShow" ? true : false}
                    onChange={(e) => setCancellationType("NoShow")}
                  />
                  <Form.Check.Label style={{ marginLeft: 12 }}>Client did not attend </Form.Check.Label>
                </Form.Check>
                <Form.Check id="cancellationType-LateCancel" name="LateCancelCancellation" type="radio" style={{ marginBottom: 8 }}>
                  <Form.Check.Input
                    name="LateCancel"
                    type="radio"
                    checked={cancellationType === "LateCancel" ? true : false}
                    onChange={(e) => setCancellationType("LateCancel")}
                  />
                  <Form.Check.Label style={{ marginLeft: 12 }}>Cancellation within 24 hours by Client </Form.Check.Label>
                </Form.Check>
                <Form.Check id="cancellationType-Provider24" name="providerCancellation24" type="radio" style={{ marginBottom: 8 }}>
                  <Form.Check.Input
                    name="providerCancellation24"
                    type="radio"
                    checked={cancellationType === "LateCancelProvider" ? true : false}
                    onChange={(e) => setCancellationType("LateCancelProvider")}
                  />
                  <Form.Label style={{ marginLeft: 12 }}>Cancellation within 24 hours by Provider</Form.Label>
                </Form.Check>
                <Form.Check id="cancellationType-Provider" name="providerCancellation" type="radio" style={{ marginBottom: 8 }}>
                  <Form.Check.Input
                    name="providerCancellation"
                    type="radio"
                    checked={cancellationType === "Provider" ? true : false}
                    onChange={(e) => setCancellationType("Provider")}
                  />
                  <Form.Label style={{ marginLeft: 12 }}>Cancelled by Provider</Form.Label>
                </Form.Check>

                {cancellationType !== "" ? (
                  <>
                    {cancellationType === "NoShow" ? (
                      <Form.Label style={{ marginLeft: 12 }}>To cancel please enter information relating to the Client not attending</Form.Label>
                    ) : (
                      <Form.Label style={{ marginLeft: 12 }}>To cancel please enter the reason for cancellation</Form.Label>
                    )}
                    <Form.Control
                      as="textarea"
                      rows={3}
                      name="cancellationReason"
                      value={cancellationReason}
                      onChange={(event) => setCancellationReason(event.target.value)}
                      autoComplete="new-password"
                    />
                    {cancellationType === "NoShow" ? (
                      <>
                        <Checkbox
                          aria-label="Send Cancellation SMS"
                          name="cancellationSMS"
                          value={cancellationTypeSMS}
                          onChange={(event) => updateCancellationTypeSMS(event.target.checked)}
                          style={{ paddingTop: 6, paddingLeft: 0 }}
                        />
                        <Form.Label style={{ marginLeft: 12 }}>Do you want to SMS the Client not attending</Form.Label>
                      </>
                    ) : null}
                    {cancellationTypeSMS ? (
                      <>
                        <Form.Label style={{ marginLeft: 12 }}>Please enter the SMS message</Form.Label>
                        <Form.Control
                          as="textarea"
                          rows={5}
                          name="cancellationTypeSMSText"
                          value={cancellationTypeSMSText}
                          onChange={(event) => setCancellationTypeSMSText(event.target.value)}
                          autoComplete="new-password"
                        />
                      </>
                    ) : null}
                  </>
                ) : null}
              </Form.Group>
            </Grid>
          </Grid>
        </Modal.Body>
        <Modal.Footer className="new-booking-modal">
          <Grid container direction="row" justifyContent="space-between" alignItems="center">
            <Grid item>
              <Button variant="secondary" size="sm" onClick={() => setShowCancelProviderBooking(false)} className="lightButtonOutlinedLarge">
                Close
              </Button>
            </Grid>
            <Grid item>
              <Button
                variant="warning"
                size="sm"
                onClick={() => cancelBooking(cancelBookingData && cancelBookingData.id)}
                disabled={!cancellationReason || (cancellationReason && cancellationReason.replace(/\s/g, "").length < 5)}
                className="lightButtonOutlinedLarge"
              >
                Cancel Booking &gt;
              </Button>
            </Grid>
          </Grid>
        </Modal.Footer>
      </Modal>

      <Modal show={showOpportunityRelevantInfo} onHide={() => setShowOpportunityRelevantInfo(false)} dialogClassName="todos-modal-dialog">
        <Modal.Header closeButton className="todos-modal">
          <Modal.Title>Please enter any relevant information to your expression of interest</Modal.Title>
        </Modal.Header>
        <Modal.Body className="todos-modal">
          <Grid item md={12}>
            <Row>
              <Col md="12">
                <Form.Group>
                  <Form.Label>Opportunity</Form.Label>
                  <p style={{ fontStyle: "italic" }}>{clientOpportunityInterest}</p>
                  <Form.Label>Relevant Info (maximum 500 characters)</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    type="text"
                    name="relevantInfo"
                    defaultValue={clientOpportunityRelevantInfo}
                    onBlur={(event) => setClientOpportunityRelevantInfo(event.target.value)}
                    autoComplete="new-password"
                    style={{ borderColor: "#D1D1D1" }}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col md="12">
                <Grid container spacing={0} padding={6} justifyContent="space-between">
                  <Button variant="light" onClick={() => setShowOpportunityRelevantInfo(false)}>
                    Cancel
                  </Button>
                  <Button variant="success" size="sm" onClick={() => expressInterest()}>
                    Express Interest
                  </Button>
                </Grid>
              </Col>
            </Row>
          </Grid>
        </Modal.Body>
      </Modal>

      <Modal show={showNotes} onHide={() => setShowNotes(false)} dialogClassName="notes-modal-dialog">
        <Modal.Header closeButton className="notes-modal">
          <Modal.Title>Communications - {currentClient && `${currentFirstName} ${currentSurname}`}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="notes-modal">
          <div className="row">
            <div className="col-xl-12">
              <Form.Group style={{ marginBottom: 5 }}>
                <Form.Label>Client</Form.Label>
                <Autocomplete
                  id="searchClient"
                  variant="outlined"
                  options={clients}
                  getOptionLabel={(option) => option.fullname}
                  value={currentClient ? currentClient : null}
                  onChange={(event, newValue) => handleClientAutocompleteChange("profileTimeZone", event, newValue)}
                  style={{ minWidth: 300, fullWidth: true, display: "flex", wrap: "nowrap" }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      type="text"
                      variant="outlined"
                      margin="dense"
                      name="ClientSelector"
                      style={{ backgroundColor: "white", margin: 0, padding: 0, maxWidth: 300 }}
                      inputProps={{
                        ...params.inputProps,
                        autoComplete: "new-password",
                      }}
                    />
                  )}
                />
              </Form.Group>
            </div>
          </div>
          {registered && currentClient ? (
            <Notes
              type="Client"
              noteAction={noteAction}
              pkid={currentClientID}
              waitingRoomURL={registered && (registered.teleHealthProvider === "COVIU" ? registered.coviuRoomURL : registered.waitingRoomURL)}
              nextBookingDate={nextBookingDate}
              psychologistFullName={registered.firstname + " " + registered.surname}
              firstName={currentFirstName}
              faxGP={client && client.referralGPPracticeFax}
              email={currentEmail}
              mobilephone={currentMobilePhone}
            />
          ) : null}
        </Modal.Body>
        <Modal.Footer className="notes-modal">
          <Button variant="secondary" onClick={() => setShowNotes(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showLetter} onHide={() => setShowLetter(false)} dialogClassName="notes-modal-dialog">
        <Modal.Header closeButton className="notes-modal">
          <Modal.Title>Send Letter - {currentClient && `${currentFirstName} ${currentSurname}`}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="notes-modal">
          <div className="row">
            <div className="col-xl-12">
              <Form.Group style={{ marginBottom: 5 }}>
                <Form.Label>Client</Form.Label>
                <Autocomplete
                  id="searchClient"
                  variant="outlined"
                  options={clients}
                  getOptionLabel={(option) => option.fullname}
                  value={currentClient ? currentClient : null}
                  onChange={(event, newValue) => handleClientAutocompleteChange("profileTimeZone", event, newValue)}
                  style={{ minWidth: 300, fullWidth: true, display: "flex", wrap: "nowrap" }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      type="text"
                      variant="outlined"
                      margin="dense"
                      name="ClientSelector"
                      style={{ backgroundColor: "white", margin: 0, padding: 0, maxWidth: 300 }}
                      inputProps={{
                        ...params.inputProps,
                        autoComplete: "new-password",
                      }}
                    />
                  )}
                />
              </Form.Group>
            </div>
          </div>
          {registered && currentClient ? (
            <ClientSendLetter
              currentClientID={currentClientID}
              registered={registered}
              currentDOB={currentDOB}
              currentPreferredName={currentPreferredName}
              currentFirstName={currentFirstName}
              currentSurname={currentSurname}
            />
          ) : null}
        </Modal.Body>
        <Modal.Footer className="notes-modal">
          <Button variant="secondary" onClick={() => setShowLetter(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
